<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import headerDefault from '@/components/App/header-default/header-default.vue';
import footerDefault from '@/components/App/footer/footer.vue';
import ticker from '@/components/App/ticker.vue';
import { useRouter, useRoute } from "vue-router";
import { useCommonComposable } from '@/composables/commonComposable.js';

import { useHead } from "@vueuse/head";

useHead({
    title: "Заказ оформлен — Baller | Оригинальные джерси",
    meta: [
        {name: 'description', content: "Описание страницы"}
    ],
})

const store = useStore();
const router = useRouter();
const route = useRoute();
const { user, getUser } = useCommonComposable();

// Переменные состояния
const orderProducts = ref([]);
const orderAddress = ref({});
const orderNumber = ref('');

async function sendMsg(number, customerEmail) {
    await axios.post(process.env.VUE_APP_API_URL + "/mail/sendMsg", {
        to: 'alexandermulyanov@gmail.com',
        subject: 'Новый заказ на сайте — Baller',
        html: `Пользователь ${customerEmail} сделал заказ на сайте https://ballershop.ru. Номер заказа: ${number}`
    })
}

async function addOrderItem() {
    return

    for (let item of orderProducts.value) {
        const data = {
            productCode: item['Код'],
            orderNumber: orderNumber.value || 0,
            quantity: 1,
            statusName: 'Archived'
        };

        try {
            await axios.post(process.env.VUE_APP_API_URL + "/orders/addOrderItem", data);
        } catch (error) {
            console.log(error);
        }
    }
}

onMounted(async () => {
    if (!localStorage.getItem('PaymentId')) {
        router.go(-2);
        return
    }

    orderProducts.value = JSON.parse(localStorage.getItem('OrderProducts'));
    if (orderProducts.value.length === 0) {
        router.go(-1);
        return;
    }

    await getUser()

    await store.dispatch('address/fetchUserAddresses', { customerId: user.value[0].ID }); // Загружаем адреса текущего пользователя
    orderAddress.value = JSON.parse(JSON.stringify(store.state.address.userAddresses)).find((item) => item["Статус"] === "Активен");

    orderNumber.value = JSON.parse(localStorage.getItem('OrderNumber'));

    localStorage.setItem('OrderProducts', '');
    localStorage.setItem('OrderNumber', '');
    localStorage.setItem('PaymentId', '');

    store.commit('RESET_MODULE', { moduleName: 'product' });
    store.commit('RESET_CART')
    store.commit('order/SET_ORDER_NUMBER', 0);

    await sendMsg(orderNumber.value, user.value[0].email)
})
</script>

<template>
    <div class="silver-background">
    <ticker></ticker>
    <header-default></header-default>
    <div class="container page column-page">
        <div class="row">
            <h3 class="page-header">Ваш заказ оформлен</h3>
        </div>
        <div class="row">
            <div class="col-lg-8 col-md-8 col-12">
                <div class="order-elems">
                    <h4 class="block-header">Список товаров</h4>
                    <div class="hr"></div>
                    <div v-for="item of orderProducts" class="order-item">
                        <router-link v-if="item['Код'] !== 'Shipping'" :to="`/products/${item['Код']}`" class="item-info">
                            <div class="item-img" :style="'background: url(' + setImageURL(item) + ')'">
                            </div>
                            <div class="item-text">
                                <div class="top">
                                    <p class="item-header">{{ item["Название продукта"] }}</p>
                                    <p class="item-size">Размер: {{ item["Размер"] }}</p>
                                </div>
                                <p class="item-price">{{ item["Цена по скидке"] }}&#8381;</p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12 sidebar">
                <div class="item-outer">
                    <h4 class="block-header">Адрес доставки</h4>
                    <div class="hr"></div>
                    <div class="item-inner" v-if="user[0]">
                        <p>{{ orderAddress["Служба доставки"] }}</p>
                        <p v-if="orderAddress['Регион'] === orderAddress['Город']">{{`${orderAddress["Индекс"]}, ${orderAddress["Страна"]}, ${orderAddress["Город"]}, ${orderAddress["Улица"]}, д. ${orderAddress["Дом"]} кв. ${orderAddress["Квартира"]}`}}</p>
                        <p v-else>{{`${orderAddress["Индекс"]}, ${orderAddress["Страна"]}, ${orderAddress["Регион"]}, ${orderAddress["Город"]}, ${orderAddress["Улица"]}, д. ${orderAddress["Дом"]} кв. ${orderAddress["Квартира"]}`}}</p>
                        <p v-if="user">{{ `${user[0]["Имя"]} ${user[0]["Фамилия"]}` }}</p>
                    </div>
                </div>

                <div class="item-outer">
                    <div class="item-inner">
                        <p v-if="user[0]">Продублировали на ваш электронный адрес ({{user[0].email}}) информацию о заказе</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <footer-default></footer-default>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;

    .order-elems, .payment-methods {
        background: $white;
        border-radius: 10px;
        padding: 20px;

        display: flex;
        flex-direction: column;
        gap: 10px
    }

    .item-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 2%;
        flex-grow: 1;
    }

    .order-item {
        background: $light-gray;
        border-radius: 10px;
        padding: 2.5%;

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .block-header {
        font-size: 16px;
        font-weight: 500;
        color: $black
    }

    .item-img {
        width: 75px;
        height: 75px;

        background-size: 100% !important;
        background-position: center;

        border-radius: 10px;
        border: 1px solid $gray;
        box-sizing: border-box;
    }

    .item-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 10px;
    }

    .item-text .top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 4px;
    }

    .item-header {
        font-size: 18px;
        font-weight: 500;
        color: $black;
    }

    .item-size {
        font-size: 14px;
        font-weight: 400;
        color: $hard-gray
    }

    .item-price {
        font-size: 14px;
        font-weight: 500;
        color: $black;
    }

    .user-addresses {
        display: flex;
        flex-direction: column;
        gap: 15px
    }

    .addresses-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 30px
    }

    .addresses-header h3 {
        margin-bottom: 0;
    }

    .item-outer {
        padding: 20px;
        box-sizing: border-box;
        background: $white;
        border-radius: 10px;

        display: flex;
        flex-direction: column;
        gap: 10px
    }

    .item-outer .address-name {
        font-size: 14px;
        font-weight: 500;
    }

    .item-inner {
        background: $light-gray;
        border-radius: 10px;
        padding: 15px;
        transition: $transition;
        cursor: pointer;
        box-sizing: border-box;
    }

    .item-inner:hover {
        background: $silver-hover;
    }

    .item-inner p {
        color: $hard-gray;
        font-size: 14px;
        font-weight: 400;
    }

    .header-address-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 5px;
        box-sizing: border-box;
    }

    .header-address-item .name {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 5px
    }

    .item-actions {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px
    }

    .item-actions span {
        font-size: 12px;
        color: $hard-gray;
        transition: $transition
    }

    .sidebar {
        display: flex;
        flex-direction: column;
        gap: 10px
    }

    @media screen and (max-width: 750px) {
        .order-elems {
            margin-bottom: 10px;
        }

        .block-header {
            font-size: 14px;
        }

        .item-inner p {
            font-size: 12px;
        }

        .item-info {
            gap: 15px
        }

        .item-header {
            font-size: 16px;
        }

        .item-size {
            font-size: 12px;
        }
    }
</style>